import { observable, action, runInAction } from 'mobx'
import remotedev from 'mobx-remotedev'

import { StoreExt } from '@utils/reactExt'

import { records } from '@services/api'

export class collectionsStore extends StoreExt {
    @observable loading = false
    @observable list = []

    @action
    getRecords = async collection_id => {
        this.loading = true
        const { data: list } = await records.getList({ collection_id })
        runInAction(() => {
            this.list = list
            this.loading = false
        })
    }

    @action
    resetRecords = () => {
        this.list = []
    }
}

export default remotedev(new collectionsStore())
